
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { Input } from '@/components/ui/input';

interface FAQSearchProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

const FAQSearch = ({ searchQuery, onSearchChange }: FAQSearchProps) => {
  return (
    <div className="max-w-2xl mx-auto mb-8">
      <div className="relative">
        <MagnifyingGlassIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-muted-foreground" />
        <Input
          type="text"
          placeholder="Search FAQs... Try 'room scan', 'family dashboard', or 'pricing'"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-12 py-4 text-lg rounded-lg border-2 focus:border-primary"
        />
      </div>
    </div>
  );
};

export default FAQSearch;
